// Framework dependencies
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs'
import { Examen } from '../exams-config/Examen.config';
import { ConfirmationService, Message } from 'primeng/api';
import { MessageAlertService } from '@app/shared/views/_messagesService/_messageAlertServices';
import { AsideService } from '@app/shared/components/aside/aside.service';
import { BackgroundSyncService } from '@app/helpers/backgroundSync.service';
import { DatabaseService } from '@app/database/database.service';
import { ExamsConfigService } from '../exams-config/exams-config.service';
import { ConnectionService, ConnectionState } from 'ng-connection-service';
import { GroupFTemplateService } from '@shared/forms/templates/group-f-template/group-f-template.service';
import moment from 'moment'
import { environment } from '@env/environment';
import { IEspecialidades } from '@app/database/models/IEspecialidades.model';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-group-f-template',
  templateUrl: './group-f-template.component.html',
  styleUrls: ['./group-f-template.component.scss'],
})
export class GroupFTemplateComponent implements OnInit, OnDestroy {

  public currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
  @Input() examen: any; // IExamen;
  submitted = false;
  public examForm: FormGroup;
  fecha: any;
  seniority = 0;
  unidadTiempo = '';
  radio: any;
  maxDate = new Date();
  maxDateIngreso = new Date();
  minDate: any;
  tiposDictamen: any[] = [];
  asideObservable: Subscription;
  displayAgentes = false;
  attachedFiles: any = {
    data: [],
    invalid: false,
    isEmpty: true,
    attachedFilesValidQuantity: 0
  };
  baseUrl = 'https://lasegundatesting.conexia.com.ar:8444/lasegunda-ml-api/exams/carga/laringoscopia';
  configForm: Examen;
  tipoExamenInvalid: boolean = false;
  listaAnosIndemnizacion: any[] = [];
  enviandose = false;
  isOnline = true;
  listaCampos: string[] = [];
  header: any;
  invalidField = false;
  checked: boolean = true;
  isAntecedentesAccidentesTrabajoPageBreak = false;
  isEstudioClinicoPageBreak = false;
  isVisionDoblePageBreak = false;
  isMareosPageBreak = true;
  isConjuntivitisPageBreak = false;
  isVisionBorrosaPageBreak = false;
  especialidades: IEspecialidades[];
  displayModalFirma = false;
	medicoFirmaB64;
  medicoFirmaSigString;

  selectedSufered: any [] = [];
  suffered: any[] = [
    { name: 'Infección de oído', checked: false, controlName: 'infeccionOido'},
    { name: 'Dolor de oído', checked: false, controlName: 'dolorOido'},
    { name: 'supuración', checked: false, controlName: 'supuracion'},
    { name: 'Tapón de cera', checked: false, controlName: 'taponCera'},
    { name: 'Otro', checked: false, controlName: 'padecidoOtro'},
    { name: 'Nada', checked: true, controlName: 'padecidoNada'}
  ];
  auricular = false;
  auditivo = false;
  membrana = false;
  studies: any[] = [
    { name: 'Empresa', value: true, controlName: 'estudioRealizadoEmpresa'},
    { name: 'Cabina audiometría', value: false, controlName: 'estudioRealizadoCabina'}
  ];
  otoscopiaEstudio:any[] = [{name:'Normal', value:true, controlName:'pabellonAuricularNormal'},
                    {name:'Anormal', value:false, controlName:'pabellonAuricularAnormal'}];
  otoscopiaConducto:any[] = [{name:'Normal', value:false, controlName:'conductoAuditivoExternoNormal'},
                    {name:'Anormal', value:false, controlName:'conductoAuditivoExternoAnormal'}];
  otoscopiaMembrana:any[] = [{name:'Normal', value:false, controlName:'membranaTimpanicaNormal'},
                    {name:'Anormal', value:false, controlName:'membranaTimpanicaAnormal'}];

  tecnico:any = ['Si', 'No'];
  ambienteRuidoso=false;
  acufenos=false;
  ruidoExtralaboral=false;
  entenderConversacion=false;
  proteccionAuditiva=false;
  eppCobertores=false;
  eppTapones=false;
  eppAmbos=false;
  reposoAuditivo=false;
  indemnizadoHipoacusia=false;
  grita=false;
  capacitacionEpp=false;
  proteccionAuditivaObligatoria=false;
  proteccionAuditivaNoProvista=false;
  inconvenientes=false;
  inconvenientesDescipcion=false;
  enfermedades=false;
  exposicionesOtotoxicas=false;

  airWay: any[] = [{name:'O.D'}];
  airWayOi: any[] = [{name:'O.I'}];
  viaBone: any[] = [{name:'O.D'}];
  viaBoneOi: any[] = [{name:'O.I'}];
  showErrorValue: boolean = false;
  padecioOtro = true;
  disabledEpp = true;
  messagesErrorPrevious: Message[];
  messagesErrorValue: Message[];
  questionClinic: boolean;
  tableAudio: any = {};

  //sólo 1 valor posible de seleccionar, solo obligatorio si eligió Si en usa protección auditiva)
  hearingProtection =  [{name:'Cobertores de Copa', value: 'eppCobertores'},
                        {name:'Tapones', value: 'eppTapones'},
                        {name:'Ambos', value: 'eppAmbos'}];
  validateTable: boolean = false;

  constructor(private titleService: Title,
    private router: Router,
    private confirmationService: ConfirmationService,
    private messageAlertServices: MessageAlertService,
    private asideService: AsideService,
    private backgroundSyncService: BackgroundSyncService,
    private databaseService: DatabaseService,
    private examConfigService: ExamsConfigService,
    private groupFTemplateService: GroupFTemplateService,
    private connectionService: ConnectionService) {
  }

  get f(): any {
    return this.examForm.controls;
  }

  ngOnInit(): void {
    this.titleService.setTitle('Provincia ART ML Offline');
    this.connectionService.monitor().subscribe( ( connected: ConnectionState ) => {
      this.isOnline = connected.hasNetworkConnection;
    })
    this.isOnline = JSON.parse(localStorage.getItem('isStillOnline'));
    this.cargarFormulario();
    this.getTiposDictamen();
    this.getEspecialidades();
    this.cargarAnios();
    this.minDate = new Date(moment(this.examen.fechaAsignacion).format());
    this.asideObservable = this.asideService.openModalSubject$.subscribe((data) => {
      this.goBack(data);
    });
    this.asideService.setInsideExamen(true);
  }

  onChangeValuePabellon(name: any, event: any) {
    let value = event.checked;
    switch (name) {
      case 'Normal':
          this.examForm.controls.pabellonAuricular.setValue('N');
          this.examForm.controls.pabellonAuricularAnormal.setValue(null);
          this.examForm.controls.pabellonAuricularDescripcionAnormal.setValue('');
          this.examForm.controls.pabellonAuricularDescripcionAnormal.disable();
          this.examForm.controls.pabellonAuricularDescripcionAnormal.updateValueAndValidity();
          break;
      case 'Anormal':
        if (value) {
          this.examForm.controls.pabellonAuricular.setValue('A');
          this.examForm.controls.pabellonAuricularNormal.setValue(null);
          this.examForm.controls.pabellonAuricularDescripcionAnormal.enable();
          this.examForm.controls.pabellonAuricularDescripcionAnormal.setValidators([
          Validators.required,
          Validators.maxLength(250),
          ]);
          this.examForm.controls.pabellonAuricularDescripcionAnormal.updateValueAndValidity();
        } else {
          this.examForm.controls.pabellonAuricularDescripcionAnormal.setValue('');
          this.examForm.controls.pabellonAuricularDescripcionAnormal.disable();
          this.examForm.controls.pabellonAuricular.setValue(null);
          this.examForm.controls.pabellonAuricularDescripcionAnormal.updateValueAndValidity();
        }
    }
  }

  onChangeValueConducto(name: any, event: any) {
    let value = event.checked;
    switch (name) {
      case 'Normal':
          this.examForm.controls.conductoAuditivoExterno.setValue('N');
          this.examForm.controls.conductoAuditivoExternoAnormal.setValue(null);
          this.examForm.controls.conductoAuditivoExternoDescripcionAnormal.setValue('');
          this.examForm.controls.conductoAuditivoExternoDescripcionAnormal.disable();
          this.examForm.controls.conductoAuditivoExternoDescripcionAnormal.updateValueAndValidity();
          break;
      case 'Anormal':
        if (value) {
          this.examForm.controls.conductoAuditivoExterno.setValue('A');
          this.examForm.controls.conductoAuditivoExternoNormal.setValue(null);
          this.examForm.controls.conductoAuditivoExternoDescripcionAnormal.enable();
          this.examForm.controls.conductoAuditivoExternoDescripcionAnormal.setValidators([
          Validators.required,
          Validators.maxLength(250),
          ]);
          this.examForm.controls.conductoAuditivoExternoDescripcionAnormal.updateValueAndValidity();
        } else {
          this.examForm.controls.conductoAuditivoExternoDescripcionAnormal.setValue('');
          this.examForm.controls.conductoAuditivoExternoDescripcionAnormal.disable();
          this.examForm.controls.conductoAuditivoExterno.setValue(null);
          this.examForm.controls.conductoAuditivoExternoDescripcionAnormal.updateValueAndValidity();
        }
    }
  }

  onChangeValueMembrana(name: any, event: any) {
    let value = event.checked;
    switch (name) {
      case 'Normal':
          this.examForm.controls.membranaTimpanica.setValue('N');
          this.examForm.controls.membranaTimpanicaAnormal.setValue(null);
          this.examForm.controls.membranaTimpanicaDescripcionAnormal.setValue('');
          this.examForm.controls.membranaTimpanicaDescripcionAnormal.disable();
          this.examForm.controls.membranaTimpanicaDescripcionAnormal.updateValueAndValidity();
          break;
      case 'Anormal':
        if (value) {
          this.examForm.controls.membranaTimpanica.setValue('A');
          this.examForm.controls.membranaTimpanicaNormal.setValue(null);
          this.examForm.controls.membranaTimpanicaDescripcionAnormal.enable();
          this.examForm.controls.membranaTimpanicaDescripcionAnormal.setValidators([
          Validators.required,
          Validators.maxLength(250),
          ]);
          this.examForm.controls.membranaTimpanicaDescripcionAnormal.updateValueAndValidity();
        } else {
          this.examForm.controls.membranaTimpanicaDescripcionAnormal.setValue('');
          this.examForm.controls.membranaTimpanicaDescripcionAnormal.disable();
          this.examForm.controls.membranaTimpanica.setValue(null);
          this.examForm.controls.membranaTimpanicaDescripcionAnormal.updateValueAndValidity();
        }
    }
  }

  clearHearingProtection() {
    this.examForm.controls.listaProtectores.disable();
    this.examForm.controls.listaProtectores.setValue(null);
    this.examForm.controls.listaProtectores.setValidators(null);
    this.examForm.controls.listaProtectores.updateValueAndValidity();
  }

  onChangeValueTecnic(request: any, $event: any){
    let isValue = $event.checked;
    switch (request) {
      case 'ambienteRuidoso':
        this.examForm.controls.ambienteRuidoso.setValue(isValue);
        break;
      case 'acufenos':
        this.examForm.controls.acufenos.setValue(isValue);
        break;
      case 'ruidoExtralaboral':
        this.examForm.controls.ruidoExtralaboral.setValue(isValue);
        break;
      case 'entenderConversacion':
        this.examForm.controls.entenderConversacion.setValue(isValue);
        break;
      case 'proteccionAuditiva':
        this.examForm.controls.proteccionAuditiva.setValue(isValue);
        if (isValue) {
          this.examForm.controls.listaProtectores.enable();
          this.examForm.controls.listaProtectores.setValidators([Validators.required]);
          this.examForm.controls.listaProtectores.updateValueAndValidity();
        } else {
          this.clearHearingProtection();
        }
        break;
      case 'reposoAuditivo':
        this.examForm.controls.reposoAuditivo.setValue(isValue);
        break;
      case 'indemnizadoHipoacusia':
        this.examForm.controls.indemnizadoHipoacusia.setValue(isValue);
        break;
      case 'grita':
        this.examForm.controls.grita.setValue(isValue);
        break;
      case 'capacitacionEpp':
        this.examForm.controls.capacitacionEpp.setValue(isValue);
         if (!isValue)
        break;
      case 'proteccionAuditivaObligatoria':
        this.examForm.controls.proteccionAuditivaObligatoria.setValue(isValue);
        break;
      case 'proteccionAuditivaNoProvista':
        this.examForm.controls.proteccionAuditivaNoProvista.setValue(isValue);
        break;
      case 'inconvenientes':
        this.examForm.controls.inconvenientes.setValue(isValue);
        if (isValue) {
          this.examForm.controls.inconvenientesDescipcion.enable();
          this.examForm.controls.inconvenientesDescipcion.setValidators([
            Validators.required,
            Validators.maxLength(250),
          ]);
          this.examForm.controls.inconvenientesDescipcion.updateValueAndValidity();
        } else {
          this.examForm.controls.inconvenientesDescipcion.setValue('');
          this.examForm.controls.inconvenientesDescipcion.disable();
          this.examForm.controls.inconvenientesDescipcion.updateValueAndValidity();
        }
        break;
    }
  }

  onChangeValueClinic(request: any, $event: any){
    let isChecked = $event.checked;
    switch (request) {
      case 'enfermedades':
        this.examForm.controls.enfermedades.setValue(isChecked);
        if (isChecked) {
          this.examForm.controls.enfermedadesDescripcion.enable();
          this.examForm.controls.enfermedadesDescripcion.setValidators([
            Validators.required,
            Validators.maxLength(250),
          ]);
          this.examForm.controls.enfermedadesDescripcion.updateValueAndValidity();
        } else {
          this.examForm.controls.enfermedadesDescripcion.setValue('');
          this.examForm.controls.enfermedadesDescripcion.disable();
          this.examForm.controls.enfermedadesDescripcion.updateValueAndValidity();
        }
        break;
      case 'exposicionesOtotoxicas':
        this.examForm.controls.exposicionesOtotoxicas.setValue(isChecked);
        if (isChecked) {
          this.examForm.controls.exposicionesOtotoxicasDescripcion.enable();
          this.examForm.controls.exposicionesOtotoxicasDescripcion.setValidators([
            Validators.required,
            Validators.maxLength(250),
          ]);
          this.examForm.controls.exposicionesOtotoxicasDescripcion.updateValueAndValidity();
        } else {
          this.examForm.controls.exposicionesOtotoxicasDescripcion.setValue('');
          this.examForm.controls.exposicionesOtotoxicasDescripcion.disable();
          this.examForm.controls.exposicionesOtotoxicasDescripcion.updateValueAndValidity();
        }
        break;
    }
  }

  onChangeValueStudy(name: string){
    switch (name) {
      case 'estudioRealizadoEmpresa':
        this.examForm.controls.estudioRealizadoEmpresa.setValue(true);
        this.examForm.controls.estudioRealizadoCabina.setValue(false);
        break;
      case 'estudioRealizadoCabina':
        this.examForm.controls.estudioRealizadoEmpresa.setValue(false);
        this.examForm.controls.estudioRealizadoCabina.setValue(true);
        break;
    }
  }

  onChangeValueNothing(name: string, $event: any){
    let isChecked = $event.checked;
    switch (name) {
      case 'infeccionOido':
        this.examForm.controls.infeccionOido.setValue(isChecked);
        this.examForm.controls.padecidoUltimoAnio.setValue(isChecked);
        this.examForm.controls.infeccionOido.updateValueAndValidity;
        this.examForm.controls.padecidoNada.setValue(false);
        break;
      case 'dolorOido':
        this.examForm.controls.dolorOido.setValue(isChecked);
        this.examForm.controls.padecidoUltimoAnio.setValue(isChecked);
        this.examForm.controls.dolorOido.updateValueAndValidity;
        this.examForm.controls.padecidoNada.setValue(false);
        break;
      case 'supuracion':
        this.examForm.controls.supuracion.setValue(isChecked);
        this.examForm.controls.padecidoUltimoAnio.setValue(isChecked);
        this.examForm.controls.supuracion.updateValueAndValidity;
        this.examForm.controls.padecidoNada.setValue(false);
        break;
      case 'taponCera':
        this.examForm.controls.taponCera.setValue(isChecked);
        this.examForm.controls.padecidoUltimoAnio.setValue(isChecked);
        this.examForm.controls.taponCera.updateValueAndValidity;
        this.examForm.controls.padecidoNada.setValue(false);
        break;
      case 'padecidoOtro':
        if (isChecked) {
          this.examForm.controls.padecidoOtro.setValue(isChecked);
          this.examForm.controls.padecidoUltimoAnio.setValue(isChecked);
          this.examForm.controls.padecidoOtroDescripcion.enable();
          this.examForm.controls.padecidoOtroDescripcion.setValidators([
            Validators.required,
            Validators.maxLength(250),
          ]);
        } else {
          this.examForm.controls.padecidoOtroDescripcion.setValue('');
          this.examForm.controls.padecidoOtroDescripcion.disable();
          this.examForm.controls.padecidoOtroDescripcion.setValidators(null);
        }
        this.examForm.controls.padecidoOtroDescripcion.updateValueAndValidity();
        this.examForm.controls.padecidoNada.setValue(false);
        break;
      case 'padecidoNada':
        if (isChecked) this.clearClinicQuestion();
        this.examForm.controls.padecidoNada.setValue(isChecked);
        this.examForm.controls.padecidoNada.updateValueAndValidity;
        break;
    }
    this.questionClinic = this.validateClinic();
  }

  clearClinicQuestion(){
    this.examForm.controls.padecidoUltimoAnio.setValue(false);
    this.examForm.controls.infeccionOido.setValue(false);
    this.examForm.controls.dolorOido.setValue(false);
    this.examForm.controls.supuracion.setValue(false);
    this.examForm.controls.taponCera.setValue(false);
    this.examForm.controls.padecidoOtro.setValue(false);
    this.examForm.controls.padecidoOtroDescripcion.setValue('');
    this.examForm.controls.padecidoOtroDescripcion.disable();
    this.examForm.controls.padecidoOtroDescripcion.updateValueAndValidity();
  }

  ngOnDestroy(): void {
    if (this.asideObservable) {
      this.asideObservable.unsubscribe();
    }
    this.asideService.setInsideExamen(false);
    this.titleService.setTitle('Provincia ART ML Offline');
  }

  cargarAnios() {
    const actual = moment().year();
    for (let i = actual; i > (actual - 70); i--) {
      this.listaAnosIndemnizacion.push({ label: i, value: i });
    }
  }

  async onSubmit(): Promise<any> {
    this.submitted = true;
    if (this.examForm.invalid || this.attachedFiles.invalid || this.questionClinic || !this.validateTable || this.medicoFirmaB64 == null) {
      this.navigateInvalidField('ng-invalid');
      return;
    }
    this.enviandose = true;
    if (this.isOnline) {
      this.saveToOnline();
    } else {
      this.saveToOffline();
    }
  }

  buildRequest() {
    let examFormData = { ...this.examForm.getRawValue() };
    examFormData.userId = this.currentUser.userId;
    examFormData.username = this.currentUser.username;
    examFormData.modelId = this.currentUser.modelId;
    examFormData.tipoEstudio = this.configForm.code;
    examFormData.examenNumero = this.examen.id;
    examFormData.fechaRealizacion = moment(examFormData.fechaRealizacion).format('yyyy-MM-DD');
    examFormData.fechaIngresoEmpresa = moment(examFormData.fechaIngresoEmpresa).format('yyyy-MM-DD');
    examFormData.antiguedadPuestoTrabajador = moment(examFormData.antiguedadPuestoTrabajador).format('yyyy-MM-DD');
    examFormData.fechaUltimaCalibracion = moment(examFormData.fechaUltimaCalibracion).format('yyyy-MM-DD');
    examFormData.adjuntos = this.attachedFiles.data;
    this.examen?.modoVista === "edit" ? examFormData.esEdicion = !!(this.examen?.modoVista === "edit" && this.isOnline) : null;
    examFormData.od125 = this.examen.od125;
    examFormData.od250 = this.examen.od250;
    examFormData.od500 = this.examen.od500;
    examFormData.od1000 = this.examen.od1000;
    examFormData.od2000 = this.examen.od2000;
    examFormData.od4000 = this.examen.od4000;
    examFormData.od6000 = this.examen.od6000;
    examFormData.od8000 = this.examen.od8000;
    examFormData.odSuma = this.examen.odSuma;
    examFormData.odPab = this.examen.odPab;
    examFormData.odTo = this.examen.odTo;
    examFormData.oi125 = this.examen.oi125;
    examFormData.oi250 = this.examen.oi250;
    examFormData.oi500 = this.examen.oi500;
    examFormData.oi1000 = this.examen.oi1000;
    examFormData.oi2000 = this.examen.oi2000;
    examFormData.oi4000 = this.examen.oi4000;
    examFormData.oi6000 = this.examen.oi6000;
    examFormData.oi8000 = this.examen.oi8000;
    examFormData.oiSuma = this.examen.oiSuma;
    examFormData.oiPab = this.examen.oiPab;
    examFormData.oiTo = this.examen.oiTo;
    examFormData.oseaod250 = this.examen.oseaod250;
    examFormData.oseaod500 = this.examen.oseaod500;
    examFormData.oseaod1000 = this.examen.oseaod1000;
    examFormData.oseaod2000 = this.examen.oseaod2000;
    examFormData.oseaod4000 = this.examen.oseaod4000;
    examFormData.oseaod6000 = this.examen.oseaod6000;
    examFormData.oseaoi250 = this.examen.oseaoi250;
    examFormData.oseaoi500 = this.examen.oseaoi500;
    examFormData.oseaoi1000 = this.examen.oseaoi1000;
    examFormData.oseaoi2000 = this.examen.oseaoi2000;
    examFormData.oseaoi4000 = this.examen.oseaoi4000;
    examFormData.oseaoi6000 = this.examen.oseaoi6000;
    examFormData.imgGraficoAudiometria = this.examen.imgGraficoAudiometria;
    examFormData.eppCobertores = examFormData.proteccionAuditiva ? this.examForm.controls.listaProtectores.value.value === 'eppCobertores' : false;
    examFormData.eppTapones = examFormData.proteccionAuditiva ? this.examForm.controls.listaProtectores.value.value === 'eppTapones' : false;
    examFormData.eppAmbos = examFormData.proteccionAuditiva ? this.examForm.controls.listaProtectores.value.value === 'eppAmbos': false;
    examFormData.medicoFirmaB64 = this.medicoFirmaB64;
    examFormData.medicoFirmaSigString = this.medicoFirmaSigString;

		examFormData = this.evaluateChangeTrabajador(examFormData);

		return examFormData;
	}

	private evaluateChangeTrabajador(object) {
		if (this.examen.seModificoTrabajador
			|| this.examen.trabajador.fechaNacimiento != moment(this.examForm.controls.fechaNacimiento.value).format('yyyy-MM-DD')
			|| this.examen.trabajador.apellidoNombre != this.examForm.controls.apellidoNombre.value) {

			object.trabajador = {
				apellidoNombre: this.examForm.controls.apellidoNombre.value,
				fechaNacimiento: moment(this.examForm.controls.fechaNacimiento.value).format('yyyy-MM-DD')
			};
			this.examen.seModificoTrabajador = true;
		}
		return object;
	}

  buildUrlApi(method: string): string {
    return `${environment.apiUrl}` + method;
  }

  _standarizeDate(date: any) {
    let splitedDate = date.replace(/\//g, '-');
    const dateParts = splitedDate.split('-');
    if (date.includes('/')) {
      return new Date(parseInt(dateParts[2]), parseInt(dateParts[1]) - 1, parseInt(dateParts[0]));
    } else {
      return new Date(parseInt(dateParts[0]), parseInt(dateParts[1]) - 1, parseInt(dateParts[2]));
    }
  }

  cargarFormulario(): void {
    let codigoTipoExamen = (this.examen.tipoEstudio.codigo !== undefined)
      ? this.examen.tipoEstudio.tipoEstudioCod
      : this.examen.tipoEstudio;
    this.configForm = this.examConfigService.getConfig(codigoTipoExamen);
    this.configForm.name = this.examen.provinciaNombreEstudio;
    this.examForm = this.configForm.examForm;
    this.examen.trabajador.apellidoNombre ? this.examForm.controls.apellidoNombre.setValue(this.examen.trabajador.apellidoNombre) : null;
    this.examen.trabajador.fechaNacimiento ? this.examForm.controls.fechaNacimiento.setValue(new Date(moment(this.examen.trabajador.fechaNacimiento).format())) : null;
    this.calculateAge();
    this.examen.puestoTrabajador ? this.examForm.controls.puestoTrabajador.setValue(this.examen.puestoTrabajador) : null;
		this.examen.antiguedadPuestoTrabajador ? this.examForm.controls.antiguedadPuestoTrabajador.setValue(this.standarizeDate(this.examen.antiguedadPuestoTrabajador)) : null;
		this.examen.fechaIngresoEmpresa ? this.examForm.controls.fechaIngresoEmpresa.setValue(new Date(moment(this.examen.fechaIngresoEmpresa).format())) : null;
    this.restrictDateIngresoEmpresa();
		this.medicoFirmaB64 = this.examen.medicoFirmaB64;
    this.medicoFirmaSigString = this.examen.medicoFirmaSigString;
    this.setValuesOnFormOnVerOrEditMode();
  }

  standarizeDate(date: any) {
		let splitedDate = date.replace(/\//g, '-');
		const dateParts = splitedDate.split('-');
		if (date.includes('/')) {
		  return new Date(parseInt(dateParts[2]), parseInt(dateParts[1]) -1, parseInt(dateParts[0]));
		} else {
		  return new Date(parseInt(dateParts[0]), parseInt(dateParts[1]) -1, parseInt(dateParts[2]));
		}
	}

  capitalize(word: string): string {
    if (!word) {
      return word;
    }
    return word[0].toUpperCase() + word.substr(1).toLowerCase();
  }

  async getTiposDictamen(): Promise<void> {
    const dataFromOffline = await this.databaseService.getAllTiposDictamenFromOfflineDB();
    this.tiposDictamen = dataFromOffline.filter(
      (x) => x.codigo === 'A' || x.codigo === 'I' || x.codigo === 'N'
    );
  }

  calcularAntiguedad(): void {
    if (this.examen.fechaAltaEmpleado) {
      this.seniority = moment().diff(
        moment(this.examen.fechaAltaEmpleado),
        'years'
      );
      if (this.seniority > 1) {
        this.unidadTiempo = 'años';
      } else if (this.seniority < 1) {
        this.seniority = moment().diff(
          moment(this.examen.fechaAltaEmpleado),
          'months'
        );
        if (this.seniority > 1) {
          this.unidadTiempo = 'meses';
        } else {
          this.unidadTiempo = 'mes';
        }
      } else {
        this.unidadTiempo = 'año';
      }
    }
  }

  // Helpers Functions
  goBack(ruta?): void {
    if (this.examForm.dirty) {
      this.confirm(ruta);
    } else {
      this.returnToExams();
    }
  }

  confirm(ruta?): void {
    this.confirmationService.confirm({
      header: `¿Está seguro que desea cancelar la carga del examen?`,
      message: `Si cancela el examen ahora perderá toda la información cargada hasta el momento`,
      key: 'goBackForm',
      accept: () => {
        this.returnToExams(ruta);
      },
    });
  }

  returnToExams(ruta?): void {
    this.router.navigate([ruta ? ruta : 'examenes']);
  }

  /**
   * función que recibe el trigger desde el componente attach-upload-file
   * con el objeto actualizado de la lista de archivos y errores
   * @param  {object} event
   * @example:
   *  {
   *    errors: {
   *      isSizeValid: false
   *      isTypeValid: false,
   *    },
   *    data: [
   *       {
   *        archivoBase64: todounstringpegado,
   *        nombreOriginal: "example.png",
   *        tipo: "png",
   *        size: 121354,
   *        esAlta:false,
   *        esBaja:false
   *    ],
   *    invalid: false,
   *    isEmpty: true,
   *    attachedFilesValidQuantity: 0
   *  }
   */
   getAttachedFiles(event: any): any {
    const {errors} = event;

    this.attachedFiles = event;
    if (errors.isSizeValid && errors.isTypeValid) {
      // asigno la data al objeto para enviar
      return false;
    }
  }

  navigateInvalidField(classFocus: string): void {
    const invalidFields = [].slice.call(
      document.getElementsByClassName(classFocus)
    );
    const field = invalidFields.length > 1 ? invalidFields[1] : invalidFields[0];
    field.scrollIntoViewIfNeeded();
    field.focus();
  }

  validPercent(event) {
    const data = event.target.value.replace(/[^0-9]/gi, '');
    if (!isNaN(data)) {
      if (Number(data) > 100) {
        this.examForm.controls.porcentajeIncapacidad.setValue(100);
        this.examForm.controls.porcentajeIncapacidad.updateValueAndValidity();
      }
    }
  }

  private saveToOnline(): void {
    this.groupFTemplateService.loadExam(this.buildRequest(), this.configForm.baseUrl).subscribe((response) => {
      this.databaseService.deleteItemFromTable(this.examen.id,
        `examenes${(this.examen.categoriaExamen === 'periodicos'
          ? 'Periodicos'
          : 'Reevaluacion')}`);
      this.databaseService.deleteItemFromTable(this.examen.id,
          `examenes${ (this.examen.categoriaExamen === 'periodicos'
          ? 'PeriodicosFiltrados'
          : 'ReevaluacionFiltrados')}`);
      this.messageAlertServices.setMessage(0, {
        severity: 'success',
        summary: '',
        detail: response.message,
        key: 'examen',
      });
      setTimeout(() => {
        this.returnToExams();
      }, 500);
      this.enviandose = false;
    }, (error) => {
      this.messageAlertServices.setMessage(0, {
        severity: 'error',
        summary: '',
        detail: error.error.response.map((x) => {
          return x.message;
        }).join(', '),
        key: 'examen',
      });
      setTimeout(() => {
        const header = document.querySelector('#templateContainer') as any;
        window.scroll(0, header.offsetTop - 250);
      }, 100);
      this.enviandose = false;
    });
  }


  private saveToOffline(): void {
    const dataToSend = this.buildRequest();
    dataToSend.fechaCarga = moment().format('yyyy-MM-DD');
    dataToSend.cargadoOffline = true;
    const details = (this.examen?.modoVista === "edit") ? 'Los cambios en el examen fueron guardados correctamente' : 'El examen se guardó correctamente en Por enviar';

    this.databaseService
      .setExameneOnExamenesPorEnviarTable(
        this.examen,
        dataToSend,
        false,
        this.examen.categoriaExamen === 'periodicos'
          ? 'Periodicos'
          : 'Reevaluacion',
        this.buildUrlApi(this.configForm.baseUrl)
      )
      .then((response) => {
        this.databaseService.deleteItemFromTable(this.examen.id,
          `examenes${(this.examen.categoriaExamen === 'periodicos'
            ? 'Periodicos'
            : 'Reevaluacion')}`);
        this.databaseService.deleteItemFromTable(this.examen.id,
          `examenes${(this.examen.categoriaExamen === 'periodicos'
            ? 'PeriodicosFiltrados'
            : 'ReevaluacionFiltrados')}`);
        this.backgroundSyncService.registerEvent('save-examen');
        this.openSuccessAlert(
          details,
          'examen'
        );
      })
      .catch((e) => {
        this.messageAlertServices.setMessage(0, {
          severity: 'error',
          summary: '',
          detail:
            'Ha ocurrido un error. Por favor reintente más tarde y disculpe las molestias ocasionadas',
          key: 'examen',
        });
      });
  }

  private openSuccessAlert(message: string, key: string): void {
    this.enviandose = false;
    this.messageAlertServices.setMessage(0, {
      severity: 'success',
      summary: '',
      detail: message,
      key: key,
    });
    setTimeout(() => {
      this.returnToExams();
    }, 500);
  }

  private calculateAge(): void {
    let edad = null;
    if (this.examForm.controls.fechaNacimiento.value) {
      edad = moment().diff(
        moment(this.examForm.controls.fechaNacimiento.value),
        'years'
      );
    }
    this.examen.trabajador.edad = edad;
  }

  restrictDateIngresoEmpresa(): void {
    if(this.examForm.controls.antiguedadPuestoTrabajador.value != null && this.examForm.controls.antiguedadPuestoTrabajador.value != "") {
      this.maxDateIngreso = this.examForm.controls.antiguedadPuestoTrabajador.value;
    } else {
      this.maxDateIngreso = this.maxDate;
    }
  }

  /**
   * @description:
   * * Asignacion de valores a los campos en modo edicion
   */
  private setValuesOnFormOnVerOrEditMode(): void {

    if (this.examen?.modoVista === "edit" || this.examen.modoVista === 'ver' || this.examen?.cargadoOffline) {
        /*********************
       * * Campos del Header
       *********************/
      this.examForm.controls.fechaRealizacion.setValue(this.examen.fechaRealizacion);

      /**********************
       *  * Campos del FOOTER
       ***********************/
      this.examen.codigoDictamen = this.examen.tipoDictamen ? this.examen.tipoDictamen : this.examen.codigoDictamen;
      this.examForm.controls.codigoDictamen.setValue(this.examen.codigoDictamen);
      this.examForm.controls.medicoEspecialidad.setValue(this.examen.medicoEspecialidad);
      this.examForm.controls.medicoMatricula.setValue(this.examen.medicoMatricula);
      this.examForm.controls.medicoNombre.setValue(this.examen.medicoNombre.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, ''));

      /*********************
       * * Cuadro Audiometría
       *********************/

      this.airWay = [{name:'O.D', od125: this.examen.od125, od250: this.examen.od250,
      od500: this.examen.od500, od1000: this.examen.od1000, od2000: this.examen.od2000,
      od4000: this.examen.od4000, od6000: this.examen.od6000, od8000: this.examen.od8000,
      odSuma: this.examen.odSuma, odPab: this.examen.odPab, odTo: this.examen.odTo}];

      this.airWayOi = [{name:'O.I', oi125: this.examen.oi125, oi250: this.examen.oi250,
      oi500: this.examen.oi500, oi1000: this.examen.oi1000, oi2000: this.examen.oi2000,
      oi4000: this.examen.oi4000, oi6000: this.examen.oi6000, oi8000: this.examen.oi8000,
      oiSuma: this.examen.oiSuma, oiPab: this.examen.oiPab, oiTo: this.examen.oiTo}];

      this.viaBone = [{name:'O.D', oseaod125: this.examen.oseaod125, oseaod250: this.examen.oseaod250,
      oseaod500: this.examen.oseaod500, oseaod1000: this.examen.oseaod1000, oseaod2000: this.examen.oseaod2000,
      oseaod4000: this.examen.oseaod4000, oseaod6000: this.examen.oseaod6000}];

      this.viaBoneOi = [{name:'O.I', oseaoi125: this.examen.oseaoi125, oseaoi250: this.examen.oseaoi250,
      oseaoi500: this.examen.oseaoi500, oseaoi1000: this.examen.oseaoi1000, oseaoi2000: this.examen.oseaoi2000,
      oseaoi4000: this.examen.oseaoi4000, oseaoi6000: this.examen.oseaoi6000}];

      this.validateTable=true;

      /************************
      * * datos del audiometro
      ************************/
      this.examForm.controls.marca.setValue(this.examen.marca);
      this.examForm.controls.fechaUltimaCalibracion.setValue(this._standarizeDate(this.examen.fechaUltimaCalibracion));
      this.examForm.controls.modelo.setValue(this.examen.modelo);
      this.examForm.controls.numeroSerie.setValue(this.examen.numeroSerie);
      this.examForm.controls.estudioRealizadoEmpresa.setValue(this.examen.estudioRealizadoEmpresa);
      this.examForm.controls.estudioRealizadoCabina.setValue(this.examen.estudioRealizadoCabina);

      /************************
      * * otoscopia
      ************************/
      this.examForm.controls.pabellonAuricular.setValue(this.examen.pabellonAuricular);
      let pabellon = this.examen.pabellonAuricular;
      if (pabellon==='N') this.examForm.controls.pabellonAuricularNormal.setValue('true');
      if (pabellon==='A') this.examForm.controls.pabellonAuricularAnormal.setValue('true');
      if (pabellon==='A') this.examForm.controls.pabellonAuricularDescripcionAnormal.enable();
      this.examForm.controls.pabellonAuricularDescripcionAnormal?.setValue(this.examen.pabellonAuricularDescripcionAnormal ? this.examen.pabellonAuricularDescripcionAnormal : "");

      this.examForm.controls.conductoAuditivoExterno.setValue(this.examen.conductoAuditivoExterno);
      let conducto = this.examen.conductoAuditivoExterno;
      if (conducto==='N') this.examForm.controls.conductoAuditivoExternoNormal.setValue('true');
      if (conducto==='A') this.examForm.controls.conductoAuditivoExternoAnormal.setValue('true');
      if (conducto==='A') this.examForm.controls.conductoAuditivoExternoDescripcionAnormal.enable();
      this.examForm.controls.conductoAuditivoExternoDescripcionAnormal?.setValue(this.examen.conductoAuditivoExternoDescripcionAnormal ? this.examen.conductoAuditivoExternoDescripcionAnormal : "");

      this.examForm.controls.membranaTimpanica.setValue(this.examen.membranaTimpanica);
      let membrana = this.examen.membranaTimpanica;
      if (membrana==='N') this.examForm.controls.membranaTimpanicaNormal.setValue('true');
      if (membrana==='A') this.examForm.controls.membranaTimpanicaAnormal.setValue('true');
      if (membrana==='A') this.examForm.controls.membranaTimpanicaDescripcionAnormal.enable();
      this.examForm.controls.membranaTimpanicaDescripcionAnormal?.setValue(this.examen.membranaTimpanicaDescripcionAnormal ? this.examen.membranaTimpanicaDescripcionAnormal : "");

       /*************************
      * * cuestionario técnico
      **************************/
      this.ambienteRuidoso = this.examen.ambienteRuidoso;
      this.examForm.controls.ambienteRuidoso.setValue(this.examen.ambienteRuidoso);
      this.acufenos = this.examen.acufenos;
      this.examForm.controls.acufenos.setValue(this.examen.acufenos);
      this.ruidoExtralaboral =  this.examen.ruidoExtralaboral;
      this.examForm.controls.ruidoExtralaboral.setValue(this.examen.ruidoExtralaboral);
      this.entenderConversacion = this.examen.entenderConversacion;
      this.examForm.controls.entenderConversacion.setValue(this.examen.entenderConversacion);
      this.proteccionAuditiva = this.examen.proteccionAuditiva;
      this.examForm.controls.proteccionAuditiva.setValue(this.examen.proteccionAuditiva);
      if (this.examen.proteccionAuditiva){
        this.examForm.controls.listaProtectores.enable();
        this.examForm.controls.listaProtectores.setValidators([Validators.required]);
        this.examForm.controls.listaProtectores.updateValueAndValidity();
        this.examForm.controls.listaProtectores.setValue(this.hearingProtection.filter(protector =>
        this.examen[protector.value]===true ? protector : null)[0]);
      }
      this.reposoAuditivo = this.examen.reposoAuditivo;
      this.examForm.controls.reposoAuditivo.setValue(this.examen.reposoAuditivo);
      this.indemnizadoHipoacusia = this.examen.indemnizadoHipoacusia;
      this.examForm.controls.indemnizadoHipoacusia.setValue(this.examen.indemnizadoHipoacusia);
      this.grita = this.examen.grita;
      this.examForm.controls.grita.setValue(this.examen.grita);
      this.capacitacionEpp = this.examen.capacitacionEpp;
      this.examForm.controls.capacitacionEpp.setValue(this.examen.capacitacionEpp);
      this.proteccionAuditivaObligatoria = this.examen.proteccionAuditivaObligatoria;
      this.examForm.controls.proteccionAuditivaObligatoria.setValue(this.examen.proteccionAuditivaObligatoria);
      this.proteccionAuditivaNoProvista = this.examen.proteccionAuditivaNoProvista;
      this.examForm.controls.proteccionAuditivaNoProvista.setValue(this.examen.proteccionAuditivaNoProvista);
      this.inconvenientes = this.examen.inconvenientes;
      this.examForm.controls.inconvenientes.setValue(this.examen.inconvenientes);
      if (this.examen.inconvenientes) this.examForm.controls.inconvenientesDescipcion.enable();
      this.examForm.controls.inconvenientesDescipcion?.setValue(this.examen.inconvenientesDescipcion ? this.examen.inconvenientesDescipcion : "");

       /*************************
      * * cuestionario clínico
      **************************/
      this.suffered = [
        { name: 'Infección de oído', checked: this.examen.infeccionOido, controlName: 'infeccionOido'},
        { name: 'Dolor de oído', checked: this.examen.dolorOido, controlName: 'dolorOido'},
        { name: 'supuración', checked: this.examen.supuracion, controlName: 'supuracion'},
        { name: 'Tapón de cera', checked: this.examen.taponCera, controlName: 'taponCera'},
        { name: 'Otro', checked: this.examen.padecidoOtro, controlName: 'padecidoOtro'},
        { name: 'Nada', checked: this.examen.padecidoNada, controlName: 'padecidoNada'}
      ];

      this.questionClinic = this.validateClinic();

      if (this.examen.padecidoOtro) this.examForm.controls.padecidoOtroDescripcion.enable();
      this.examForm.controls.padecidoOtroDescripcion?.setValue(this.examen.padecidoOtroDescripcion ? this.examen.padecidoOtroDescripcion : "");
      this.enfermedades = this.examen.enfermedades;
      this.examForm.controls.enfermedades.setValue(this.examen.enfermedades);
      this.examForm.controls.enfermedadesDescripcion?.setValue(this.examen.enfermedadesDescripcion ? this.examen.enfermedadesDescripcion : "");
      this.exposicionesOtotoxicas = this.examen.exposicionesOtotoxicas;
      this.examForm.controls.exposicionesOtotoxicas.setValue(this.examen.exposicionesOtotoxicas);
      this.examForm.controls.exposicionesOtotoxicasDescripcion?.setValue(this.examen.exposicionesOtotoxicasDescripcion ? this.examen.exposicionesOtotoxicasDescripcion : "");
    }
  }

  //CLINIC
  validateClinic(): boolean {
    const filter = this.suffered.filter(s => s.checked);
    this.checked = filter.length === 0;
    if (this.checked) this.examForm.setErrors({ invalid: true });
    return this.checked;
  }

  // ESPECIALIDADES
  async getEspecialidades(): Promise<void> {
    const especialidadesListFromOffline = await this.databaseService.getAllEspecialidadesFromOfflineDB();
    this.especialidades = especialidadesListFromOffline;
  }

  showModalFirma(){
		this.displayModalFirma = true;
	}
	closeModalFirma(){
		this.displayModalFirma = false;
	}

  recibirDatosFirma(datos: { firmaB64: string, firmaSigString: string }) {
    this.medicoFirmaB64 = datos.firmaB64;
		this.medicoFirmaSigString = datos.firmaSigString;
  }

  isValid(isValid: boolean) {
    this.validateTable = isValid;
  }

  addTableItems(tableItems: any) {
    this.tableAudio = tableItems;
    this.examen.od125 = this.tableAudio.od125;
    this.examen.od250 = this.tableAudio.od250;
    this.examen.od500 = this.tableAudio.od500;
    this.examen.od1000 = this.tableAudio.od1000;
    this.examen.od2000 =  this.tableAudio.od2000;
    this.examen.od4000 =  this.tableAudio.od4000;
    this.examen.od6000 =  this.tableAudio.od6000;
    this.examen.od8000 =  this.tableAudio.od8000;
    this.examen.odSuma =  this.tableAudio.odSuma;
    this.examen.odPab =  this.tableAudio.odPab;
    this.examen.odTo =  this.tableAudio.odTo;
    this.examen.oi125 =  this.tableAudio.oi125;
    this.examen.oi250 =  this.tableAudio.oi250;
    this.examen.oi500 =  this.tableAudio.oi500;
    this.examen.oi1000 =  this.tableAudio.oi1000;
    this.examen.oi2000 =  this.tableAudio.oi2000;
    this.examen.oi4000 =  this.tableAudio.oi4000;
    this.examen.oi6000 =  this.tableAudio.oi6000;
    this.examen.oi8000 =  this.tableAudio.oi8000;
    this.examen.oiSuma =  this.tableAudio.oiSuma;
    this.examen.oiPab =  this.tableAudio.oiPab;
    this.examen.oiTo =  this.tableAudio.oiTo;
    this.examen.oseaod250 =  this.tableAudio.oseaod250;
    this.examen.oseaod500 =  this.tableAudio.oseaod500;
    this.examen.oseaod1000 =  this.tableAudio.oseaod1000;
    this.examen.oseaod2000 =  this.tableAudio.oseaod2000;
    this.examen.oseaod4000 =  this.tableAudio.oseaod4000;
    this.examen.oseaod6000 =  this.tableAudio.oseaod6000;
    this.examen.oseaoi250 =  this.tableAudio.oseaoi250;
    this.examen.oseaoi500 =  this.tableAudio.oseaoi500;
    this.examen.oseaoi1000 =  this.tableAudio.oseaoi1000;
    this.examen.oseaoi2000 =  this.tableAudio.oseaoi2000;
    this.examen.oseaoi4000 =  this.tableAudio.oseaoi4000;
    this.examen.oseaoi6000 =  this.tableAudio.oseaoi6000;
    this.examen.imgGraficoAudiometria =  this.tableAudio.imgGraficoAudiometria;
  }

  deshabilitarApellidoNombreTrabajador() {
    return this.examen.trabajador.apellidoNombre.replace(/[^a-zA-Z]/g, '').toLowerCase() !== 'alta' && this.examen.trabajador.apellidoNombre.trim().length !== 0;
 }
}
